import * as React from 'react';
import { Link } from 'react-router-dom';
import { Title } from '../title';
import { ClickElement } from '../form';
import { userLogout } from '../../apis/user';
import { STEMTHANKYOU } from '../../lib/labels';

export const StemThankYou = () => (
  <>
    <Title Tag='h2'>
      {STEMTHANKYOU.TITLE}
    </Title>
    <p>
      {STEMTHANKYOU.TEXT}
    </p>    
    <ClickElement
      ElementType={Link}
      text={STEMTHANKYOU.BUTTON_CONTINUE}
      to={'/latest'}
      primary
    />
    <ClickElement
      tertiary
      ElementType="a"
      type="button"
      text={STEMTHANKYOU.BUTTON_LOGOUT}
      href={userLogout()}
      rel="noopener noreferrer"
    />       
  </>
);